module.exports = __webpack_public_path__ + "img/logo.c1d5706.svg";